import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import Tooltip from '@atlaskit/tooltip';
import ArrowLeftIcon from '@atlaskit/icon/core/migration/arrow-left';
import { IconButton } from '@atlaskit/button/new';
import { useTheme } from '../theme';
import { SearchIcon } from '../icons';
import { MobileSearchIconWrapper, DesktopSearchIconWrapper, SearchInputContainer, SearchInputField, ArrowIconWrapper, HiddenTooltip } from './search-input.styled';
import { SearchInputOverlay } from './search-input-overlay';
var MAX_INPUT_LENGTH = 500;
export var SearchInput = function SearchInput(_ref) {
  var onInput = _ref.onInput,
    onClick = _ref.onClick,
    onEnter = _ref.onEnter,
    isExpanded = _ref.isExpanded,
    placeholder = _ref.placeholder,
    forwardRef = _ref.forwardRef,
    value = _ref.value,
    theme = _ref.theme,
    tooltipContent = _ref.tooltipContent,
    onBack = _ref.onBack,
    showClearButton = _ref.showClearButton,
    onClear = _ref.onClear,
    allowChangeExpand = _ref.allowChangeExpand,
    exitSearchLabel = _ref.exitSearchLabel,
    clearSearchLabel = _ref.clearSearchLabel,
    onSelect = _ref.onSelect,
    toggleAISearchButton = _ref.toggleAISearchButton,
    shouldFillContainer = _ref.shouldFillContainer;
  var handleInput = function handleInput(e) {
    if (onInput) {
      onInput(e.currentTarget.value);
    }
  };
  var handleClick = function handleClick(e) {
    if (onClick) {
      onClick(e);
    }
  };
  var handleTabEnter = function handleTabEnter(e) {
    if (e.key === 'Enter' && onClick) {
      onClick();
    }
  };
  var handleKeyDown = function handleKeyDown(e) {
    var _e$nativeEvent;
    if ((_e$nativeEvent = e.nativeEvent) !== null && _e$nativeEvent !== void 0 && _e$nativeEvent.isComposing || e.keyCode === 229) {
      return;
    }
    if (!e.defaultPrevented && e.key === 'Enter') {
      e.preventDefault();
      onEnter && onEnter(e);
    }
  };
  var handleSelect = function handleSelect(e) {
    if (onSelect) {
      onSelect(e);
    }
  };
  var TooltipComponent = tooltipContent && !isExpanded ? undefined : HiddenTooltip;
  return /*#__PURE__*/React.createElement(Tooltip, {
    content: tooltipContent,
    component: TooltipComponent,
    position: "bottom"
  }, /*#__PURE__*/React.createElement(SearchInputContainer, _extends({}, theme, {
    shouldFillContainer: shouldFillContainer,
    isExpanded: isExpanded,
    role: "search"
  }), /*#__PURE__*/React.createElement(MobileSearchIconWrapper, {
    isExpanded: isExpanded
  }, /*#__PURE__*/React.createElement(IconButton, {
    label: "Search",
    onClick: handleClick,
    icon: function icon() {
      return /*#__PURE__*/React.createElement(SearchIcon, {
        theme: theme,
        isExpanded: isExpanded,
        size: "medium"
      });
    }
  })), /*#__PURE__*/React.createElement(DesktopSearchIconWrapper, _extends({}, theme, {
    isExpanded: isExpanded,
    onKeyPress: handleTabEnter
  }), /*#__PURE__*/React.createElement(SearchIcon, {
    theme: theme,
    isExpanded: isExpanded
  })), isExpanded && /*#__PURE__*/React.createElement(ArrowIconWrapper, _extends({}, theme, {
    onClick: onBack
  }), /*#__PURE__*/React.createElement(ArrowLeftIcon, {
    label: exitSearchLabel || 'Exit Search',
    LEGACY_size: "large",
    color: "currentColor"
  })), /*#__PURE__*/React.createElement(SearchInputField, _extends({
    "data-test-id": "search-dialog-input",
    onInput: handleInput,
    onChange: handleInput,
    onKeyDown: handleKeyDown,
    onClick: handleClick,
    onSelect: handleSelect,
    isExpanded: isExpanded,
    placeholder: placeholder,
    ref: forwardRef || undefined,
    value: value,
    maxLength: MAX_INPUT_LENGTH,
    "aria-label": placeholder
  }, theme)), (showClearButton || !!toggleAISearchButton) && /*#__PURE__*/React.createElement(SearchInputOverlay, {
    theme: theme,
    showClearButton: showClearButton,
    onClear: onClear,
    allowChangeExpand: allowChangeExpand,
    clearSearchLabel: clearSearchLabel,
    toggleAISearchButton: toggleAISearchButton
  })));
};
export default /*#__PURE__*/React.forwardRef(function (props, ref) {
  var theme = useTheme();
  return /*#__PURE__*/React.createElement(SearchInput, _extends({}, props, {
    theme: theme,
    forwardRef: ref
  }));
});